import { isEmpty } from 'lodash-es'
import { toast } from 'react-toastify'

import { PAY_WITH_SAVED_CARD_ERROR_KEY } from '@/constants/errorData'

interface ErrorData {
  errorCode: number
  errorData: any
  message: any
  name: string
  status: number
}

interface ToastData {
  error: ErrorData
  closeButton?: boolean
  autoClose?: number
}

interface ToastConfig {
  toastId: string
  theme?: any
  autoClose: number
}

const handleErrorByToast = ({ error, autoClose = 6000 }: ToastData) => {
  const toastConfig: ToastConfig = { toastId: 'api_error', autoClose }

  const noToastList: Set<boolean> = new Set([
    // 使用者無權限進入 Live Mall Club VIP 直播間，已有彈窗，不 toast error
    error.name === 'FetchRoomCanAccessApi' && error.status === 403,
    // 已刪除直播間不跳錯誤 toast
    error.name === 'FETCH_ROOM_KOL_LIST' && error.message.includes('room not found'),
    // 已綁卡付款的業務錯誤碼由呼叫端給專屬文案（SDC-2607）
    error.name === 'PAY_WITH_SAVED_CARD' && error.errorCode in PAY_WITH_SAVED_CARD_ERROR_KEY,
  ])

  if (noToastList.has(true)) {
    return
  }

  if (error.errorCode > 0) {
    toast.error(`${error?.message}`, { ...toastConfig })
  } else if (!error.errorCode && !error?.status) {
    toast.error(`[${error?.name}] 網路不穩定 請重試一次`, { ...toastConfig })
  } else if (!isEmpty(`error.errorCode`) && error.errorCode === -5) {
    toast.error(`[${error?.name}] Name exceeds maximum length of 64 characters`, { ...toastConfig })
  } else {
    toast.error(`[${error?.name}]  code: ${error?.errorCode}, message: ${error?.message}`, { ...toastConfig })
  }
}

export default handleErrorByToast
